import Header from "./components/Header";
import Meme from "./components/Meme";

export default function App() {
  return (
    <div className="App">
      <Header />
      <Meme />
    </div>
  );
}